<div class="popup-wrap request-popup">
    <div class="popup-header" fxLayout="row" fxLayoutAlign="space-between center">
        <h5>Request to
            <ng-container *ngIf="data?.type=='leave'">
                Leave
            </ng-container>
            <ng-container *ngIf="data?.type=='join'">
                Join
            </ng-container>
            <ng-container *ngIf="data?.type=='rejoin'">
                Re-join
            </ng-container>
            "{{data?.workspace?.workspaceName}}”
        </h5>
        <a href="javascript:void(0)" fxLayoutAlign="center center" (click)="onNoClick()">
            <span class="icon-box icon-va-close"></span>
        </a>
    </div>
    <div class="popup-content">
        <div class="instructions m-b-20">
            <strong>When you <ng-container *ngIf="data?.type=='leave'">
                    Leave
                </ng-container>
                <ng-container *ngIf="data?.type=='join'">
                    Join
                </ng-container>
                <ng-container *ngIf="data?.type=='rejoin'">
                    Re-join
                </ng-container> a workspace, the following
                will
                occur:
            </strong>
            <p>- You get access to the workspace and all the resources.</p>
            <p>- You can Request to <ng-container *ngIf="data?.type=='leave'">
                    Leave
                </ng-container>
                <ng-container *ngIf="data?.type=='join'">
                    Join
                </ng-container>
                <ng-container *ngIf="data?.type=='rejoin'">
                    Re-join
                </ng-container> whenever you want.
            </p>
        </div>
        <div class="input-container form-group">
            <label for="">Please tell, why do you want to
                <ng-container *ngIf="data?.type=='leave'">
                    Leave
                </ng-container>
                <ng-container *ngIf="data?.type=='join'">
                    Join
                </ng-container>
                <ng-container *ngIf="data?.type=='rejoin'">
                    Re-join
                </ng-container>
            </label>
            <div class="input-bx">
                <textarea class="form-textarea" id="" type="text" required [(ngModel)]="reason" name="reason"></textarea>
            </div>
        </div>
       </div> 
        <div class="popup-footer" fxLayoutGap="8px" fxLayout="row" fxLayoutAlign="flex-end center">
            <button mat-button class="tertiary-cta" (click)="onNoClick()">Cancel</button>
            <button mat-button class="primary-cta" [disabled]="!reason" fxFlex="110px" (click)="saveData()">
                <ng-container *ngIf="btnLoader; else textTemp">
                    <mat-spinner [diameter]=20></mat-spinner>
                </ng-container>
                <ng-template #textTemp> Send
                    Request </ng-template>
            </button>
        </div>
</div>